<script setup>
import { ref } from 'vue'
import Search from "@/components/Search.vue";
import Breadcrumbs from "@/components/common/Breadcrumbs.vue";
import NotificationPanel from "@/components/notifications/NotificationPanel.vue";
import { useNotifications } from '@/composables/useNotifications'

const notificationPanelRef = ref()
const { unreadCount } = useNotifications()

const toggleNotifications = (event) => {
  notificationPanelRef.value?.toggle(event)
}
</script>

<template>
  <div>
    <!-- Узкие и до 1023px: сверху Search + колокольчик, ниже Breadcrumbs -->
    <header class="w-full px-4 flex flex-col gap-2 lg:hidden">
      <div class="flex items-center justify-between gap-3">
        <Search />
        <i
          class="pi pi-bell cursor-pointer bell-icon"
          :class="{ 'bell-icon-active': unreadCount > 0 }"
          @click="toggleNotifications"
        ></i>
      </div>
      <div>
        <Breadcrumbs />
      </div>
    </header>

    <!-- С 1024px и шире: как было (Breadcrumbs слева, Search+колокольчик справа) -->
    <header class="w-full px-4 hidden lg:flex items-center justify-between gap-3">
      <Breadcrumbs />
      <div class="flex items-center gap-3 ">
        <Search />
        <i
          class="pi pi-bell cursor-pointer bell-icon"
          :class="{ 'bell-icon-active': unreadCount > 0 }"
          @click="toggleNotifications"
        ></i>
      </div>
    </header>

    <NotificationPanel ref="notificationPanelRef" />
  </div>
</template>



<style scoped>
.bell-icon {
  color: gray;
  font-size: 1.25rem;
  transition: color 0.2s ease;
}

.bell-icon-active {
  color: #ef4444 !important;
}

.bell-icon:hover {
  opacity: 0.8;
}
</style>